<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Catálogo Extensión Tratamiento</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:end" class="textoSubtitulo">Admin_extensión</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-2 col-md-12"></div>
      <b-container fluid="">
        <b-row>
          <b-col>
            <div>
              <loading :active.sync="loading"></loading>
              <b-row class="text-center mt-4">
                <b-col cols="1" md="3">
                </b-col>
                <b-col cols="9" md="6" >
                  <b-row class="contenedorTablaSinColor" style="background:white " v-if="$localStorageService.can('Tx_extension_busq')">
                    <b-col cols="10" lg="11" class="pr-0">
                      <b-input-group class="pl-3" >
                        <b-form-input
                            class="input-filter"
                            maxLength="15"
                            v-model="filtro.extensionTratamiento"
                            type="search"
                            id="filterInput"
                            responsive
                            placeholder="Búsqueda de extensión tratamiento"
                            @keydown.enter.native="buscarCatalogo()"
                        >
                        </b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col cols="2" lg="1" class="pl-0">
                      <b-button
                          class="mt-1 pb-1"
                          size="sm"
                          variant="info"
                          :disabled="loading"
                          @click="buscarCatalogo()"
                          responsive
                          v-if="$localStorageService.can('Tx_extension_alta')"
                      >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
                        <span v-else><b-spinner small></b-spinner></span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="text-left mt-auto mb-auto">
                  <b-button
                      variant="primary"
                      title="Alta de Extensión"
                      class="paddingbotones botonesAzulFuerte"
                      responsive
                      @click="llamarModal(null,1)"
                  ><em class="vale_svg icon-boton"></em>
                  </b-button>
                </b-col>
              </b-row>
              <b-row >
                <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                  <b-table
                      :hover="true"
                      :small="true"
                      style="font-size: 12px !important; padding: 0.1rem;"
                      responsive
                      fixed
                      :fields="fields"
                      :items="items"
                      :per-page="registrosPorPagina"
                      :current-page="currentPage"
                      thead-tr-class="columnasTablaSinColorLetter"
                  >

                    <template v-slot:cell(Acciones)="row" style="width: 200px">
                      <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                                v-if="row.item.registroActivo  && $localStorageService.can('Tx_extension_editar')"
                                title="Editar"
                                @click="llamarModal(row.item,2)">
                        <em class="editar_svg sm"></em>
                      </b-button>

                      <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                                v-if="!row.item.registroActivo && $localStorageService.can('Tx_extension_reactivar')"
                                title="Activar Extensión"
                                @click="activarDesactivar(row.item)">
                        <em class="fa fa-undo"></em>
                      </b-button>
                      <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                                title="Dar de baja"
                                @click="activarDesactivar(row.item)"
                                v-if="row.item.registroActivo && $localStorageService.can('Tx_extension_inactivar')">
                        <em class="eliminar_svg icon-boton"></em>
                      </b-button>
                    </template>
                  </b-table>
                  <div align="center" v-if="loading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <b-col v-else>
                    <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
                  </b-col>
                </b-col>
                <div class="mt-2 w-100 flex justify-content-center align-items-end">
                  <b-pagination
                      align="center"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="registrosPorPagina"
                  ></b-pagination>
                </div>
              </b-row>
              <b-modal
                  v-model="mostrarModal"
                  size="xl"
                  class="redondeo"
                  centered
                  :no-close-on-backdrop="true"
                  hide-footer>

                <template #modal-header="{ ok, close }">
                  <div class="seccionTitle mLeft h5">
                    <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
                    <div class="headerTxt mLeft">{{titulo}}</div>
                  </div>
                </template>
                <div>
                  <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
                  <b-form @submit.stop.prevent="guardar">
                    <div>
                      <b-tabs class="mr-3 ml-3">
                        <b-tab class="p-0">
                          <template #title>
                            Datos del Extensión
                          </template>
                          <div class="scrollPorTabs mt-1">
                            <b-row class="mb-2">
                              <b-col>
                                <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Datos generales</p>
                              </b-col>
                            </b-row>
                            <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
                              <b-col>
                                <b-form-group align="left">
                                  <label class="letter">Extensión Tratamiento <validacion/> </label>
                                  <b-input-group size="sm">
                                    <b-form-input
                                        class="redondeo"
                                        id="idNombreCorto"
                                        placeholder="extensión del tratamiento"
                                        :state="validateState('extensionTratamiento')"
                                        v-model="$v.objGuardar.extensionTratamiento.$model"
                                    ></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </div>
                        </b-tab>
                        <div class="text-center">
                          <b-button
                              class="mt-3 botonesAzulFuerte"
                              variant="primary"
                              style="margin:10px"
                              @click="$refs.submitGuardar.click()">Guardar</b-button>

                          <b-button
                              class="mt-3 botonesGrisFuerte"
                              style="margin:10px"
                              @click="() => { mostrarModal = !mostrarModal}">Cancelar
                          </b-button>
                          <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
                        </div>
                      </b-tabs>
                    </div>
                  </b-form>
                </div>
              </b-modal>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {validationMixin} from "vuelidate";
import {maxLength, required} from "vuelidate/lib/validators";
export default {
  components: {
    Header
  },
  name: "Extension",
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      objGuardar: {
        extensionTratamiento: null
      },
      loading: false,
      filtroSeleccionado: 1,
      filtro:{
        idExtensionTratamiento: null,
        extensionTratamiento: ""
      },
      fields: [
        {key: "idExtensionTratamiento", label: "ID Extensión", sortable: true},
        {key: "extensionTratamiento", label: "Extensión", sortable: true},
        "Acciones",
      ],
      currentPage: 1,
      items: [],
      registrosPorPagina:10,

      mostrarModal: false,
      titulo: "",
      objetoSeleccionado: null,
      mostrarGuardar: false
    }
  },mounted(){
    this.buscarCatalogo()
  },
  computed: {
    rows() {
      return this.items.length;
    },

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.$nextTick(() => {
      this.$v.$reset()
    });
  },
  mixins: [validationMixin],
  validations: {
    objGuardar: {
      extensionTratamiento: {required, maxLength: maxLength(100)}
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    buscarCatalogo(){
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "catalogos/obtenerExtensionTratamiento",this.filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    llamarModal(item,id) {
      if(id== 2) {
        this.objGuardar = JSON.parse(JSON.stringify(item));
        this.mostrarModal = true;
        this.titulo = "Modificar extensión";
      }else{
        this.objGuardar = {
          extensionTratamiento: null
        };
        this.mostrarModal = true;
        this.titulo = "Agregrar extensión";
      }
    },
    activarDesactivar(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la extensión?' : '¿Está seguro de activar la extensión?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idExtensionTratamiento: item.idExtensionTratamiento,
          }
          this.$http.post(this.$api + 'catalogos/activarDesactivarExtensionTratamiento', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La extensión se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    guardar() {
      if(!this.$v.objGuardar.extensionTratamiento.$invalid){
        this.$http
            .post(this.$api + "catalogos/guardarExtensionTratamiento", this.objGuardar)
            .then((response) => {
              if (response.status === 200) {
                this.$swal.fire({
                  position: "center",
                  icon: response.data.data != null ? "success" : "info",
                  title: "Aviso",
                  text: response.data.data != null ? "extension de  tratamiento registrado correctamente" : response.data.message,
                  showConfirmButton: false,
                  timer: 3500,
                });
                if (response.data.data != null){
                  this.limpiarDatos();
                }

                this.$nextTick(() => {
                  this.$v.$reset()
                });
              }
            }).catch((error)=>{
          console.error(error);
        }).finally(() => {
          this.buscarCatalogo();
          this.mostrarModal = !this.mostrarModal
        });
      }
      /**/
    }
  }
}
</script>

<style scoped>
.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}
.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
</style>
